export const environment = {
  useMocks: false,
  // '/api' (not the full origin) — proxy.conf.json forwards this prefix
  // server-side to the real test backend, so the browser only ever talks to
  // localhost:4200 (same-origin) and CORS never applies. Only takes effect
  // through the dev-server proxy (`ng serve --configuration testing`) — the
  // proxy isn't present when serving a built output directly (e.g. via
  // server.mjs), so this environment isn't meant for that path.
  apiBaseUrl: '/api',
  // Off outside production — see analytics.ts and environment.ts.
  firebaseConfig: null,
};
